import React, { useState } from "react";
import "../Assests/Scss/Instructions.scss";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
// Below is for import images
import Vector from "../Assests/Images/Vector.png";
import Designer from "../Assests/Images/Cimages/Designer.webp";
// Below is for import components
import CopyRight from "../Reusablecomponents/Copyright";
import InternetChecking from "../Reusablecomponents/Network";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import Single from "../Assests/Images/Instructions/SingleSubject.png";
import Double from "../Assests/Images/Instructions/DualSubjects.png";
import Triple from "../Assests/Images/Instructions/ThriSubjects.png";

import ITop from "../Assests/Images/Instructions/ITop.png";
import IBottom from "../Assests/Images/Instructions/IBottom.png";
import IMiddle from "../Assests/Images/Instructions/IMiddle.png";

import English from "../Assests/Images/Instructions/English.png";
import Language from "../Assests/Images/Instructions/Language.png";
import Mathematics from "../Assests/Images/Instructions/Mathematics.png";
import Science from "../Assests/Images/Instructions/Science.png";

import { FaQuestion } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";
import { IoTimeOutline } from "react-icons/io5";

import { HiOutlineExclamationCircle } from "react-icons/hi";
import { CiPlay1 } from "react-icons/ci";
const Instructions = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));

  const Subjects = JSON.parse(localStorage.getItem("SUbjectData"))?.["Subjects"];
  const [CheckBox, UnCheckBox] = useState(false);
  const [DButton, SetDButton] = useState(false);
  const [CheckBoxAlert, SetCheckBoxAlert] = useState();

  const OpenANswersheet = async () => {
    SetDButton(true);
    if (navigator.onLine) {
      if (!CheckBox) {
        SetCheckBoxAlert("Please select the check box");
        SetDButton(false);
      } else {
        SetCheckBoxAlert("");
        const StudentAttendanceparam = {
          ContestCreationId: AssessmentData.contestCreationID,
          UserId: items.userId,
          AssessmentType: AssessmentData.assessmentType,
          SubjectName:
            AssessmentData?.testType === "single"
              ? AssessmentData?.subject1Name
              : "",
          StudentGrade: items?.grade,
        };
        await axios
          .post(
            process.env.REACT_APP_API_BASE_URL +
            "/Assessment/InsertStudentAttendance",
            StudentAttendanceparam,
            {
              headers: { XApiKey: process.env.REACT_APP_XApiKey },
            }
          )
          .then((res) => {
            SetDButton(false);
            navigate("/Student/Answersheet", { replace: true });
          })
          .catch((err) => {
            console.log(err);
            SetDButton(false);
          });
      }
    }
  };

  const RenderListImage = () => {
    switch (true) {
      case AssessmentData?.assessmentType === 3 && items?.grade <= 10:
        return [Double, 2, "DoubleSubjects"];
      case AssessmentData?.testType === "multiple":
        return [Triple, 3, "TripleSubjects"];
      default:
        return [Single, 1, "SingleSubject"];
    }
  };
  const SUbIcons = (e) => {
    switch (e) {
      case "Mathematics":
        return [Mathematics, "#AD46FF", "#F6EEFF"];
      case "English":
        return [English, "#FF8204", "#FFF1E3"];
      case "Hindi":
        return [Language, "#F85F8D", "#FCEDF6"];
      case "Telugu":
        return [Language, "#F85F8D", "#FCEDF6"];
      default:
        return [Science, "#01CEB8", "#D9FCF5"];
    }
  }
  return (
    <>
      <div className="container-fluid Instructions-pages">
        <InternetChecking />

        <div className="dflex JSAround gap-5 IMain-Div">
          <div className="dflex flexd-column alignitems" >
            <img src={ITop} alt=" Instructions Top" className="Sub-Images"/>
            <div className="dflex alignitems gap-3">
              <img src={IMiddle} alt="Instructions Middle" className=""/>
              <div className="dflex flexd-column gap-3">
                {AssessmentData?.allSubjectNames.split(",").map((Sub, index) => (
                  <div className="ISubject-Details dflex alignitems gap-5 JSBetween" style={{ backgroundColor: SUbIcons(Sub.trim())?.[2] }}>
                    <div>
                      <img src={SUbIcons(Sub.trim())?.[0]} alt="Subject Icons" style={{ backgroundColor: SUbIcons(Sub.trim())?.[1] }} />  {Sub}
                    </div>
                    <div className="dflex gap-3 IEach-Subject">
                      <div className="dflex flexd-column gap-2">
                        <span><FaQuestion style={{ color: SUbIcons(Sub.trim())?.[1] }} /> {AssessmentData?.allSubjectNoofQuestion.split(",")[index]}</span>
                        <span>QUESTIONS</span>
                      </div>
                      <div className="dflex flexd-column gap-2">
                        <span><FaStar style={{ color: SUbIcons(Sub.trim())?.[1] }} /> {AssessmentData?.allSubjectWeightage.split(",")[index]} </span>
                        <span>MARKS</span>
                      </div>
                      <div className="dflex flexd-column gap-2">
                        <span><IoTimeOutline style={{ color: SUbIcons(Sub.trim())?.[1] }} /> {AssessmentData?.allSubjectDuration.split(",")[index]}</span>
                        <span>DURATION</span>
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            </div>
            <img src={IBottom} alt="Instructions Bottom" className="Sub-Images"/>
          </div>
          <div className="Card">
            <div className="dflex flexd-column IHeading">
              <span>Please read the instructions carefully</span>
              {/* <span>Please go through the instructions carefully before continuing.</span> */}
            </div>
            <hr />
            <div className="IGuidelines">
              General Guidelines
              <ol className="LIstImg mt-3">
                <li>
                  <WithTranslate name="InstructionsPage.InstrictionA" />
                </li>
                <li>
                  <WithTranslate name="InstructionsPage.InstructionB" />
                </li>
                <li>
                  <WithTranslate name="InstructionsPage.InstructionC" />
                </li>
              </ol>
            </div>
            <div className="Important-Note dflex gap-3">
              <HiOutlineExclamationCircle />
              <div className="dflex flexd-column">
                <span>Important Note</span>
                <span>Once you submit the assessment, you cannot make any changes. Make sure to review all your answers before final submission.</span>
              </div>
            </div>
            <div className="ICheckBox">
              <input type="checkbox" name="myCheckbox" checked={CheckBox} disabled={DButton}
                onChange={() => { SetCheckBoxAlert(""); UnCheckBox(!CheckBox); }}
                onKeyDown={(e) => { if (e.key === "Enter") { SetCheckBoxAlert(""); UnCheckBox(!CheckBox); } }} />
              {/* <WithTranslate name="InstructionsPage.FinalInstruction" /> */}
              I have read and understood all the instructions and I am ready to begin the assessment
            </div>
            <button
              className=" Buttons StarTest-Button w-100"
              // 
              style={!CheckBox || DButton ? { backgroundColor: "#E2F0EE", color: "#1CA27A" } : {}}
              disabled={DButton} onClick={OpenANswersheet} >
              {DButton ? "Loading..." : <><CiPlay1 /> Start Assessment</>}
            </button>
            <div className="ITimer">
              <IoTimeOutline />
              <div className="dflex flexd-column">
                <span>Assessment Timer</span>
                <span>Timer will start when you begin</span>
              </div>
            </div>
          </div>
        </div>
          <CopyRight />


















































        {/* <Row>
          <Col className="sdetails">
            <img
              src={RenderListImage()[0]}
              alt="Students"
              className="studentsi"
            />
            <div className={RenderListImage()[2]}>
              {RenderListImage()[2] === "DoubleSubjects" ? (
                <>
                  {Subjects.map((Sub, i) => (
                    <div className={`Subject${i + 1}`}>
                      <div className="Subject dflex">
                        {" "}
                        <span>{Sub}</span>{" "}
                      </div>
                      <div className="Sdetails dflex ">
                        <span>
                          {" "}
                          <WithTranslate name="InstructionsPage.Questions" />{" "}
                        </span>
                        <span>:</span>
                        <span>
                          {" "}
                          {AssessmentData.allSubjectNoofQuestion.split(",")[i]}
                        </span>
                        <span>
                          {" "}
                          <WithTranslate name="InstructionsPage.Weightage" />{" "}
                        </span>
                        <span>:</span>
                        <span>
                          {" "}
                          {AssessmentData.allSubjectWeightage.split(",")[i]}
                        </span>
                        <span>
                          {" "}
                          <WithTranslate name="InstructionsPage.Duration" />{" "}
                        </span>
                        <span>:</span>{" "}
                        <span>
                          {" "}
                          {AssessmentData.allSubjectDuration.split(",")[i]} Min
                        </span>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {Array.from({ length: RenderListImage()[1] }, (_, i) => (
                    <div className={`Subject${i + 1}`}>
                      <div className="Subject dflex">
                        {" "}
                        <span>
                          {AssessmentData[`subject${i + 1}Name`]}
                        </span>{" "}
                      </div>
                      <div className="Sdetails dflex ">
                        <span>
                          {" "}
                          <WithTranslate name="InstructionsPage.Questions" />{" "}
                        </span>
                        <span>:</span>
                        <span>
                          {" "}
                          {AssessmentData[`subject${i + 1}Question`]}
                        </span>
                        <span>
                          {" "}
                          <WithTranslate name="InstructionsPage.Weightage" />{" "}
                        </span>
                        <span>:</span>
                        <span>
                          {" "}
                          {AssessmentData[`subject${i + 1}QuestionWeightage`]}
                        </span>
                        <span>
                          {" "}
                          <WithTranslate name="InstructionsPage.Duration" />{" "}
                        </span>
                        <span>:</span>{" "}
                        <span>
                          {" "}
                          {AssessmentData[`sub${i + 1}Duration`]} Min
                        </span>
                      </div>
                    </div>
                  ))}{" "}
                </>
              )}
            </div>
          </Col>
          <Col className="alinment dflex flexd-column ">
            <div className="Mpoints">
              <WithTranslate name="InstructionsPage.ReadInstruction" />
            </div>
            <ol className="LIstImg">
              <li>
                <WithTranslate name="InstructionsPage.InstrictionA" />
              </li>
              <li>
                <WithTranslate name="InstructionsPage.InstructionB" />
              </li>
              <li>
                <WithTranslate name="InstructionsPage.InstructionC" />
              </li>
            </ol>
            <div
              className="BlinkingText text-danger p-2"
              style={{
                border: "2px solid red",
                borderRadius: "10PX",
                fontSize: "18px",
              }}
            >
              <b>
                <MdOutlineSpeakerNotes />{" "}
                <WithTranslate name="InstructionsPage.Note" />
              </b>{" "}
              <WithTranslate name="InstructionsPage.Note1" />
              {AssessmentData?.assessmentTime}
              {""}
              <WithTranslate name="InstructionsPage.Note2" />
            </div>
            <div className="Points-Checkbox dflex flexd-column">
              <span>
                <WithTranslate name="InstructionsPage.StartAssessment" />
              </span>
              <span>
                {" "}
                <input
                  type="checkbox"
                  name="myCheckbox"
                  checked={CheckBox}
                  disabled={DButton}
                  onChange={() => {
                    SetCheckBoxAlert("");
                    UnCheckBox(!CheckBox);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      SetCheckBoxAlert("");
                      UnCheckBox(!CheckBox);
                    }
                  }}
                />
                <WithTranslate name="InstructionsPage.FinalInstruction" />
              </span>
              {CheckBoxAlert && (
                <span className="text-danger">{CheckBoxAlert}</span>
              )}
            </div>
            <button
              className="StarTest-Button Buttons Poppins"
              style={
                !CheckBox || DButton
                  ? { backgroundColor: "#E2F0EE", color: "#1CA27A" }
                  : {}
              }
              disabled={DButton}
              onClick={OpenANswersheet}
            >
              {DButton ? "Loading..." : "Start"}
            </button>
          </Col>

          <div style={{ position: "fixed", bottom: "0px" }}>
            <CopyRight />
          </div>
        </Row> */}
      </div>
    </>
  );
};
export default Instructions;
